/**Dependencies */
import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import useAutoSlideOnView from "../hooks/useAutoSlideOnView";

/**Components */
import { Row, Col, Button, Card } from "react-bootstrap";
import Slider from "react-slick";
import { SectionAdvise } from "../components/SectionAdvise";
import { settingsCertificado, settingsDestinos } from "../utils";
import { PrincipalBanner } from "../components/PrincipalBanner";
import { CarouselCards } from "../components/CarouselCards";

/**Styles */
import "../styles/home.scss";

/**Images */
import logoSsl from "../images2/ssl.png";
import logoRnt from "../images2/RNT.png";
import logoAlap from "../images2/alap.png";
import logoRetur from "../images2/returq.png";
import bannerEnmascararGrupoMovil from "../images2/enmascarar grupo.png";
import bannerEnmascararGrupo from "../images2/enmascarar grupo movil.png";
import { getAllDestinations } from "../services/adminProductService";
import { CarruselHotels } from "../components/CarruselHotels";
import { getCollections } from "../services/CollectionsService";
import { UpnifyAssistant } from "../UpnifyAssistant";
export const Home = () => {
  const sliderRef = useRef(null);
  const sectionRef = useAutoSlideOnView(sliderRef, 60000); // Llamar el hook
  const navigate = useNavigate();
  const today = new Date();
  const [destinations, setDestinations] = useState([]);
  const [collections, setCollections] = useState([]);
  const [dates] = useState([
    new Date(today.getFullYear(), today.getMonth(), today.getDate() + 15)
      .toISOString()
      .split("T")[0],
    new Date(today.getFullYear(), today.getMonth(), today.getDate() + 17)
      .toISOString()
      .split("T")[0],
  ]);

  const certificados = [
    { img: logoSsl, margin: "0px", width: "200px" },
    { img: logoRnt, margin: "0px", width: "150px" },
    { img: logoRetur, margin: "30px", width: "230px" },
    { img: logoAlap, margin: "0px", width: "150px" },
  ];

  /** Este useEffect se encarga de obtener los destinos administrados desde el panel de administracion */
  useEffect(() => {
    const getDestinations = async () => {
      try {
        const response = await getAllDestinations(1);
        setDestinations(response);
      } catch (error) {
        throw new Error("Error fetching Data. Destinations: " + error);
      }
    };
    getDestinations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const obtenerCollections = async () => {
      try {
        const response = await getCollections();
        setCollections(response);
      } catch (error) {
        throw new Error("Error fetching Data. Destinations: " + error);
      }
    };
    obtenerCollections();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="home">
      <PrincipalBanner
        principalTitle="Encuentra y reserva una habitación "
        principalSubTitle="Conoce hasta donde puedes llegar y haz recuerdos memorables."
        idSeccion={1}
        infoTraslados={[]}
        destination={[]}
        aeropuertoFrom={[]}
        hotelTo={[]}
      />
      <div className="carousel-container-selector">
        <CarouselCards
          title="Destinos inigualables por conocer"
          cardsInfo={destinations}
          selectedDates={dates}
          urlService={"/alojamientos"}
          seccion="home"
        />
      </div>
      <div className="section-about-reservation section-advise container py-0 py-sm-5 py-lg-5">
        <SectionAdvise />
      </div>
      <div className="section-banner-enjoy mb-5 mb-sm-0 mb-lg-0">
        <img
          src={bannerEnmascararGrupo}
          alt="banner disfruta"
          className="bannerEnmascararGrupo img-enjoy"
        />
        <img
          src={bannerEnmascararGrupoMovil}
          alt="banner disfruta"
          className="bannerEnmascararGrupoMovil img-enjoy"
        />
        <Link
          to={"/circuitos"}
          onClick={() => {
            window.scroll({
              top: 0,
              left: 0,
              behavior: "smooth",
            });
          }}
        >
          <Button
            type="button"
            className="btn-float-right lucky-day-home text-nowrap w-auto p-3"
            style={{
              background: "transparent",
              border: "2px solid #fff",
            }}
          >
            Hoy es mi día de suerte
          </Button>
        </Link>
      </div>

      <div
        ref={sectionRef}
        className="section-cards-hotel cards-hotels-home container p-4 pt-2 pt-sm-5 pt-lg-5"
        //style={{ height: "47rem" }}
      >
        <CarruselHotels idSeccion={1} idTitulo={0} />
      </div>

      <div className="section-activities">
        <div className="d-flex justify-content-between mt-5 mt-sm-2 mt-lg-5 align-items-center mb-4 container">
          <h3 className="text-lg-start text-center fw-bold title-home pb-3 mb-4 border-1 border-black border-bottom hotel-ideal">
            Conoce nuestras colecciones
          </h3>
          <h5
            className="title-home d-lg-flex d-none text-start"
            style={{ fontSize: "30px", width: "30rem" }}
          >
            Los mejores destinos para tu viaje en tu temporada favorita del año.
          </h5>
        </div>
        <div className="d-md-block d-none">
          <Row className="p-0 pe-0 ps-0 m-0">
            {collections?.map((collection, index) => (
              <Col key={index + 1} md={4} xs={6} className="image-box p-0">
                <Link
                  to={`/colecciones?category=${collection?.name_collection}&idCategory=${collection?.id}`}
                  onClick={() => {
                    window.scroll({ top: 0, left: 0, behavior: "smooth" });
                  }}
                >
                  <img
                    src={`https://panel.marzahtravel.com/assets/uploads/colecciones/lista/${collection?.image_home}`}
                    className="img-collage w-100 hover-image"
                    alt=""
                  />
                  <div className="overlay-text actividades align-items-center w-100 text-center">
                    <span>{collection?.name_collection}</span>
                    <div className="" style={{ top: "125px", right: "-89px" }}>
                      <Button
                        className="p-2 rounded-5 ps-lg-5 w-auto pe-lg-5 btn-blue w-100 btn-size-colecciones"
                        style={{ width: "100%" }}
                      >
                        Descubre más
                      </Button>
                    </div>
                  </div>
                </Link>
              </Col>
            ))}
          </Row>
        </div>
        <div className="d-md-none d-block" style={{ height: "30rem" }}>
          <Slider {...settingsDestinos}>
            {collections?.map((collection, index) => (
              <Card
                key={index + 1}
                className="card-hotels d-flex p-2 border-0 justify-content-center"
                style={{ width: "18rem", height: "28rem", border: "0" }}
              >
                <Card.Img
                  variant="top"
                  src={`https://panel.marzahtravel.com/assets/uploads/colecciones/lista/${collection?.image_home}`}
                  style={{
                    height: "14rem",
                    borderRadius: "0.5rem",
                    marginBottom: "0.5rem",
                  }}
                />
                <Card.Body className="shadow" style={{ height: "160px" }}>
                  <Row>
                    <Col lg={12} style={{ lineHeight: "13px" }}>
                      <p
                        className="text-start text-purple font-weight-bold text-highlight hotel-hover"
                        style={{ lineHeight: "19px", color: "#3764ab" }}
                      >
                        {collection?.name_collection}
                      </p>
                    </Col>
                    <Col lg={12} style={{ lineHeight: "13px" }}>
                      <p
                        className="text-purple font-weight-bold text-highlight hotel-hover"
                        style={{ lineHeight: "19px", textAlign: "justify" }}
                      >
                        {collection?.description}
                      </p>
                    </Col>
                  </Row>
                </Card.Body>
                <Card.Footer
                  className="shadow border-0 bg-white"
                  style={{ borderRadius: "0rem 0rem 0.5rem 0.5rem" }}
                >
                  <Row className="">
                    <Col
                      lg={12}
                      className="text-center text-purple"
                      style={{ lineHeight: "0px" }}
                    >
                      <Button
                        onClick={() => [
                          window.scrollTo({ top: 0, behavior: "smooth" }),
                          navigate(
                            `/colecciones?category=${collection.name_collection}&idCategory=${collection.id}`
                          ),
                        ]}
                        className="p-2 rounded-5 ps-lg-5 w-auto pe-lg-5 btn-blue w-100 btn-size-colecciones"
                      >
                        Descubre más
                      </Button>
                    </Col>
                  </Row>
                </Card.Footer>
              </Card>
            ))}
          </Slider>
        </div>
      </div>

      <div className="section-certificates container py-5">
        <div>
          <h2 className="text-purple text-center">
            Somos una empresa mexicana con respaldo oficial a nivel federal
          </h2>
          <div className="divider-container">
            <hr />
          </div>
        </div>
        <div className="slider-container">
          <div className="d-md-block d-none">
            <Slider {...settingsCertificado} className="align-items-center">
              {certificados.map((imgCertificado, index) => (
                <div className="d-flex justify-content-center" key={index + 1}>
                  <img
                    src={imgCertificado.img}
                    alt=""
                    style={{
                      marginTop: imgCertificado.margin,
                      width: imgCertificado.width,
                    }}
                  />
                </div>
              ))}
            </Slider>
          </div>
          <Row className="d-md-none d-flex align-items-center justify-content-center">
            <Col lg={2} md={3} xs={6} className="text-center">
              <img src={logoSsl} alt="" className="certificados" />
            </Col>
            <Col lg={2} md={3} xs={6} className="text-center">
              <img src={logoRetur} alt="" className="certificados" />
            </Col>
            <Col lg={2} md={3} xs={6} className="text-center">
              <img src={logoRnt} alt="" className="certificados" />
            </Col>
            <Col lg={2} md={3} xs={6} className="text-center">
              <img src={logoAlap} alt="" className="certificados" />
            </Col>
            {/* <Col lg={2} md={3} xs={6} className="text-center">
              <img src={logoAlap} alt="" className="w-100" />
            </Col> */}
          </Row>
        </div>
      </div>
      <UpnifyAssistant />
    </div>
  );
};
